export default __webpack_public_path__ + "static/media/10.6e717b37.jpg";